{
  "version": "v4.3.0",
  "name": "PoolRouterDemo",
  "bytecodeTemplate": "010103004026004270b41700{8}1600{0}{1}{2}{3}{4}{6}{7}13091308{5}010017081707170617051704170317021701{8}0c2f4c405016000d0c{7}010116007a13c40de0b6b3a7640000a2160113c40de0b6b3a7640000a3160016000b0613800f4240110e16040125181816007a160113c40de0b6b3a7640000a3160213c40de0b6b3a7640000a3160016000b0613800f4240110e16050125181816007a160113c40de0b6b3a7640000a3160313c40de0b6b3a7640000a3160016000b0613800f4240110e16060125181816007a160213c40de0b6b3a7640000a3160313c40de0b6b3a7640000a3160016000b0613800f4240110e1607012518180c6717090d67170a0e67170b0f67170c{8}0d2f4c403ecd16010d13c9010000000000000000000000001400110d16080105170d16007a13c40de0b6b3a7640000a2160113c40de0b6b3a7640000a3160016000b0613800f4240110e160d012518181400170e16001602a5170f1600160113c40de0b6b3a7640000a316001600160203120a13c101000276a30d2a160e13070e1605012a181816001602a5160f2b0c331343e97b{8}0e2f4c40241603160c44171016001603a517111600160113c40de0b6b3a7640000a316001600160303120a13c101000276a30d2a161013070e1605012a181816001603a516112b0c331343ea7b{8}0f2f4c40241601160b44171216001601a517131600160213c40de0b6b3a7640000a316001600160103120a13c101000276a30d2a161213070e1607012a181816001601a516132b0c331343eb7b{8}102f4c40241602160a44171416001602a517151600160313c40de0b6b3a7640000a316001600160204120a13d0fffd8963efd1fc6a506488495d951d5263988d260d2b161413070e1606012a181816001602a516152b0c331343ec7b{8}112f4c40221400171616001601a517171600160213c40de0b6b3a7640000a316001600160104120a13d0fffd8963efd1fc6a506488495d951d5263988d260d2b161613070e1605012a181816001601a516172b0c331343ed7b{8}13062f4c40221400171816001602a517191600160113c40de0b6b3a7640000a316001600160103123613c101000276a30d2a161813070e1605012a181816001602a516192b130a2f1343ee7b{8}13072f4c40241601160a44171a16001603a5171b1600160113c40de0b6b3a7640000a316001600160103123613c101000276a30d2a161a13070e1607012a181816001603a5161b2b130a2f1343f07b{8}13082f4c40241601160b44171c16001602a5171d1600160113c40de0b6b3a7640000a316001600160104123613d0fffd8963efd1fc6a506488495d951d5263988d260d2b161c13070e1607012a181816001602a5161d2b130a2f1343f07b{8}13092f4c40241602160a44171e16001603a5171f1600160213c40de0b6b3a7640000a316001600160203123613c101000276a30d2a161e13070e1606012a181816001603a5161f2b130a2f1343f07b{8}130a2f4c40221400172016001601a517211600160213c40de0b6b3a7640000a316001600160204123613d0fffd8963efd1fc6a506488495d951d5263988d260d2b162013070e1605012a181816001601a516212b130a2f1343ee7b{8}130b2f4c40271601160b44cd44160944172216001602a51723160013c40de0b6b3a7640000a216001600cd04123613d0fffd8963efd1fc6a506488495d951d5263988d260d2b162213070e1607012a181816001602a516232b130a2f1343f07b{8}130c2f4c40261601160b44cd4416094417241600a417251600160213c40de0b6b3a7640000a316001600cd03120a13c101000276a30d2a162413070e1607012a18181600a416252b0c331343eb7b",
  "fieldsSig": {
    "names": [
      "pool_",
      "position_",
      "tick_",
      "word_",
      "factory_",
      "user_",
      "config_",
      "dexAccount_",
      "counter"
    ],
    "types": [
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}